import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { RoleManagementService } from '@services/role.management.service';
import { UserService } from '@services/user.service';
import { AccountAdminRole } from '@configs/role.config';
import { WebErrorService } from '@services/webError.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.scss']
})
export class RolesComponent implements OnInit, OnDestroy {

  roleName = "";
  roleDescription = "";
  dataSource: any;
  noDataFound: boolean = false;
  displayedColumns: string[] = ['role', 'rolePrivileges', 'roleUpdated'];
  AccountAdminRole: any;
  private unsubscribe: Subject<void> = new Subject<void>();
  isHidden = false;
  videoLink: any = '../../../assets/video/test-delivery.mp4'

  @ViewChild(MatPaginator, { static: false }) set content(paginator: MatPaginator) {
    if(this.dataSource){
      this.dataSource.paginator = paginator;
    }
  }
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  constructor(private router: Router,
    private routerstate: ActivatedRoute,
    public roleSer: RoleManagementService,
    private webErrorService: WebErrorService,
    private UserService: UserService,
    public translate: TranslateService) {
      this.AccountAdminRole = AccountAdminRole.accountAdmin;
    }

  ngOnInit(): void {
    this.getRoles();
  }

  open_in_new_window(features, link) {
    var new_window;
    if(features !== undefined && features !== '') {
      new_window = window.open('', '_blank', features);
    }
    else {
      new_window = window.open('', '_blank');
    }

    let video = '<video controls controlsList="nodownload" style="width: 100%; height: 100vh;"><source src="' + link + '" type="video/mp4" /></video>'

    if(link !== null && link !== '') {
      new_window.document.write('<!doctype html><html><head><title>Video Player</title><meta charset="UTF-8" /></head><body style="padding: 0; margin: 0;" oncontextmenu="return false">' + video + '</body></html>');
    }
  }

  ngAfterViewInit(): void {
    document.onclick = (args: any) : void => {
      if(args.target.className != 'trainingIcon') {
        this.isHidden = false;
      }
    }
  }

  getRoles() {
    this.UserService.getRoles().subscribe((data) => {
      if (data.data.length == 0) {
        this.noDataFound = true;
      } else {
        this.noDataFound = false;
        this.dataSource = new MatTableDataSource(data.data);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.setPaginator();
      }

    }, (error: any) => {
      this.webErrorService.handleAPIErrors(error);
    });
  }

  setPaginator(): void {
    setTimeout(() => {
      if (this.dataSource.paginator) {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.translate.stream([
          'roles.pagination.pageLabel',
          'roles.pagination.firstPage',
          'roles.pagination.lastPage',
          'roles.pagination.nextPage',
          'roles.pagination.prevPage'
        ]).pipe(takeUntil(this.unsubscribe)).subscribe(translation => {
          console.log(translation['roles.pagination.pageLabel'])
            this.dataSource.paginator._intl.itemsPerPageLabel = translation['roles.pagination.pageLabel'];
            this.dataSource.paginator._intl.firstPageLabel = translation['roles.pagination.firstPage'];
            this.dataSource.paginator._intl.lastPageLabel = translation['roles.pagination.lastPage'];
            this.dataSource.paginator._intl.nextPageLabel = translation['roles.pagination.nextPage'];
            this.dataSource.paginator._intl.previousPageLabel = translation['roles.pagination.prevPage'];

            this.dataSource.paginator._intl.changes.next();
        });
      }
    }, 300);
    // ------Set translation for pagination------
  }

  addRole() {
    this.router.navigate(["../Assign-privileges"], { relativeTo: this.routerstate });
  }

  roleFilter() {
    this.UserService.searchRoles(encodeURIComponent(this.roleName), encodeURIComponent(this.roleDescription)).subscribe((data) => {
      this.noDataFound = false;
      this.dataSource = new MatTableDataSource(data.data);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      if (data.data.length == 0) this.noDataFound = true;
    }, (error: any) => {
      this.webErrorService.handleAPIErrors(error);
    });
  }

  resetFilter() {
    this.roleName = '';
    this.roleDescription = '';
    this.getRoles();
  }

  navigateToRoles(id) {
    if (this.roleSer.accessData.updateAllowed) {
      this.router.navigate(["../Assign-privileges", id], { relativeTo: this.routerstate });
    }
  }

  ngOnDestroy(): void {
    // this.unsubscribe.next();
    // this.unsubscribe.complete();
  }
}
